import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedSearch } from '@/hooks/useUrlSyncedSearch';

const route = getRouteApi('/_auth/market-promotion/budget-entry');

export function useDonationBudgetSearch() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const budgetSearch = useUrlSyncedSearch({
    appliedText: search.search,
    onApply: (text) => {
      void navigate({
        search: (previous) => ({ ...previous, search: text }),
        replace: true,
      });
    },
  });

  return { ...budgetSearch, search };
}
